import { addDoc, collection } from "firebase/firestore";
import { Transaction } from "../../types/budgethelper";
import { firebaseDB } from "../../firebase";

export const useCreateTransaction = () => {
  const transactionCollectionRef = collection(firebaseDB, "transactions");
  const createTransaction = async (transaction: Transaction) => {
    await addDoc(transactionCollectionRef, transaction);
  };
  return { createTransaction };
};